export default "__VITE_ASSET__452a6264__"